import MasterClientApp from '@/src/masterClientApp'
import MasterClientOrders from '@/pages/masterClient/Orders/index.vue'
import MasterClientOrdersSidebar from '@/components/sidebars/masterClient/OrdersSidebar'
import MasterClientSystemInformations from '@/pages/masterClient/systemInformations/index'
import MasterClientProfiles from '@/pages/masterClient/Profiles/index'
import MasterClientEmail from '@/pages/masterClient/Emails/index.vue'

export default {
  path: '/master_client',
  component: MasterClientApp,
  meta: { requiresAuth: true },
  children: [
    {
      path: '',
      redirect: { name: 'masterClientOrders' }
    },
    {
      path: 'orders',
      name: 'masterClientOrders',
      components: {
        default: MasterClientOrders,
        subSidebar: MasterClientOrdersSidebar
      }
    },
    {
      path: 'system_informations',
      name: 'masterClientSystemInformations',
      component: MasterClientSystemInformations
    },
    {
      path: 'profiles',
      name: 'masterClientProfiles',
      component: MasterClientProfiles
    },
    {
      path: 'emails',
      name: 'masterClientEmails',
      components: {
        default: MasterClientEmail
      }
    }
  ]
}
